import React, { useEffect, useState } from "react";
import { StyleSheet, View } from "react-native";
import Cards from "../../../../Components/CardDesign/index";
import FuturePrePage from "../../../../Components/FuturePrePage";
import { listenOrientationChange } from "../../../../Utils/responsive";

const Index = (props) => {
  const [question, setQuestion] = useState(null);
  const [showPrePage, setShowPrePage] = useState(true);

  useEffect(() => {
    listenOrientationChange();
  }, []);

  if (showPrePage) {
    return <FuturePrePage handleStart={() => setShowPrePage(false)} />;
  }

  return (
    <View style={styles.main}>
      <Cards {...props} question={question} />
    </View>
  );
};

export default Index;

const styles = StyleSheet.create({
  main: {
    flex: 1,
    height: "100vh",
    width: "100vw",
    backgroundColor: "#9f3469",
  },
});
